/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  SearchResults,
  SearchRetrieveParams
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type searchRetrieveResponse200 = {
  data: SearchResults
  status: 200
}

export type searchRetrieveResponseSuccess = (searchRetrieveResponse200) & {
  headers: Headers;
};
;

export type searchRetrieveResponse = (searchRetrieveResponseSuccess)

export const getSearchRetrieveUrl = (params?: SearchRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/search/?${stringifiedParams}` : `/api/v1/search/`
}

/**
 * Return a list of all users.
 */
export const searchRetrieve = async (params?: SearchRetrieveParams, options?: RequestInit): Promise<searchRetrieveResponse> => {

  return customFetch<searchRetrieveResponse>(getSearchRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


